/**
 * Input Related Session
 *
 * Explains "Related sources": tables that a relation column of the source
 * table links to, and why the source table cannot be one itself.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputRelatedSession(t: I18n): TutorialSession {
  return {
    id: 'automation:inputRelated',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-section="related-tables"]',
        title: t['com.streamlain.streamlain.coach.related.title'](),
        content: t['com.streamlain.streamlain.coach.related.content'](),
        animation: 'pulse',
      },
    ],
  };
}
